import React from 'react';
import api from '../api';

export default function BlogCard({ blog, onDeleted, openEditModal }) {
 

  
  const handleDelete = async () => {
    try {
     await api.delete(`/blogs/${blog.id}`);
      onDeleted(); // refresh list
    } catch (err) {
      console.error('Error deleting blog:', err);
    }
  };

  return (
    <div className="bg-white p-4 sm:p-6 rounded shadow hover:shadow-lg transition dark:bg-gray-800 dark:border-gray-700">
      <img src={blog.imageUrl} alt={blog.title} className="w-full h-32 sm:h-40 object-cover rounded mb-4" onError={(e) => { e.target.style.display = 'none'; }} />
      <h3 className="text-lg sm:text-xl font-semibold text-black dark:text-blue-400">{blog.title}</h3>
      <p className="text-xs sm:text-sm text-gray-500 mt-1 dark:text-gray-100">{blog.description}</p>
      <p className="text-xs text-gray-400 mt-2">
        Posted: {new Date(blog.createdAt).toLocaleDateString()} • Updated: {new Date(blog.updatedAt).toLocaleDateString()}
      </p>
      <div className="flex flex-wrap justify-end gap-2 mt-4">
        <button onClick={handleDelete} className="text-red-600 hover:text-red-800">🗑️</button>
        <button onClick={() => openEditModal(blog)} className="text-blue-600 hover:text-blue-800">✏️</button>
      </div>
    </div>
  );
}